import React, { useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import AppButton from "../Button";
import { exportToExcel } from "../../../../utils/functions";

export default function TableExportButton({
  className = "",
  disabled = false,
  filename = "TableExport",
  label = "Export",
  loading = false,
  mapRow = (row) => row,
  onExport,
  plain = false,
  rows = [],
  stopPropagation = false,
  variant = "outline",
}) {
  const [exporting, setExporting] = useState(false);
  const isExporting = loading || exporting;


  const handleExport = useCallback(async (event) => {
    if (stopPropagation) {
      event?.stopPropagation?.();
    }

    if (isExporting) return;

    setExporting(true);
    try {
      if (onExport) {
        await onExport();
        return;
      }

      if (!rows.length) return;

      await exportToExcel({
        excelData: rows.map(mapRow),
        filename: typeof filename === "function" ? filename() : filename,
      });
    } finally {
      setExporting(false);
    }
  }, [filename, isExporting, mapRow, onExport, rows, stopPropagation]);

  const isDisabled = disabled || (!onExport && rows.length === 0);
  const content = (
    <>
      {plain && isExporting ? (
        <span className="spinner-border spinner-border-sm" />
      ) : null}
      <FontAwesomeIcon icon={faDownload} />{" "}
      {isExporting ? "Preparing..." : label}
    </>
  );

  if (plain) {
    return (
      <button
        type="button"
        className={["table-export-button", className].filter(Boolean).join(" ")}
        disabled={isDisabled || isExporting}
        onClick={handleExport}
      >
        {content}
      </button>
    );
  }

  return (
    <AppButton
      className={["table-export-button", className].filter(Boolean).join(" ")}
      disabled={isDisabled}
      loading={isExporting}
      onClick={handleExport}
      variant={variant}
    >
      {content}
    </AppButton>
  );
}
